import { User } from "@functions-types";

export const formatUserName = <T extends Pick<User, "displayName" | "email" | "active">>
  (user: T): string => `${user.displayName} (${user.email})${user.active ? "" : " (inactive)"}`;
